// extracted by mini-css-extract-plugin
export default {"notFound":"notFound-bCvzA"};